<p-toolbar id="app-header" styleClass="app-header" [class.sidebar-expanded]="!isSidebarCollapsed">
    <div class="p-toolbar-group-left screen-lg" role="region" aria-label="Welcome Message">
        <h5 id="header-welcome-message" *ngIf="currentUser">
            {{ welcomeMessage | translate }},
            <span id="header-user-first-name">{{ currentUser.firstName ? currentUser.firstName : null }}!</span>
        </h5>
        <span *ngIf="currentUser?.laboratoryId" class="lab-container">
            <i class="fa-solid fa-pipe"></i>
            <p id="header-user-group">{{ currentUser?.laboratoryName }}</p>
        </span>
    </div>

    <div class="p-toolbar-group-left screen-sm">
        <div id="sidebar-header-logo">
            <a [routerLink]="'/'">
                <img src="assets/images/app-logo.svg" id="app-logo" alt="app-logo" />
            </a>
            <div>
                <p id="app-title-header">CheckMate</p>
                <p id="app-subtitle-header">Transnetyx</p>
            </div>
        </div>
    </div>

    <div class="p-toolbar-group-right">
        <app-toolbar></app-toolbar>
    </div>
</p-toolbar>
